module.exports = __webpack_public_path__ + "static/media/dev.623571ba.svg";